import React from "react";
import icon1 from "../Assets/Images/payout.png";
import icon2 from "../Assets/Images/in.png";
import funding from "../Assets/Images/funding.png";
import withdraw from "../Assets/Images/withdrawal.png";
import { useNavigate } from "react-router-dom";
import emptyState from "../Assets/Images/emptyState.png";
import { formatAmount } from "../utils/formatAmount";
import { timeformatter } from "../utils/dateformatter";

const PayoutTableRow = ({
  iconSrc,
  name,
  description,
  id,
  status,
  amount,
  remaining_balance,
  amount_paid,
  successBgColor,
}) => {
  const navigate = useNavigate();
  return (
    <div className="flex  justify-between items-center gap-4 p-3 border-b">
      <div className="flex items-center gap-4 w-[200px]">
        {/* <div className="w-[45px] flex-shrink-0">
          <img
            src={iconSrc}
            alt="icon"
            className="w-[38px] h-[38px] object-contain"
          />
        </div> */}
        <div className="flex flex-col">
          <span className="font-[500] text-[12px] text-[#131E3D]">{name}</span>
          <span className="text-[11px] font-[400] text-[#9C9C9E]">
            {description}
          </span>
        </div>
      </div>
      <div className="w-[130px]">
        {status?.toLocaleLowerCase() === "paid" ? (
          <span className=" text-[12px] min-w-fit items-center capitalize flex justify-center font-[400] bg-[#E4FFC2] px-[14px] h-[27px] p-1 rounded-[40px]  text-[#344616] ">
            {status}
          </span>
        ) : (
          <span className=" text-[12px] min-w-fit items-center capitalize flex justify-center font-[400] bg-[#F2F2F7] px-[14px] h-[27px] p-1 rounded-[40px]  text-[#131E3D] ">
            {status}
          </span>
        )}
      </div>
      {/* <span
        className={`text-[14px] min-w-[80px] font-[400] px-[10px] justify-center items-center flex h-[27px] p-1 rounded-[40px] text-center ${successBgColor}`}
      >
        {success}
      </span> */}
      <div className="flex items-center w-[150px] justify-center">
        <span className="text-[#131E3D] font-[500] text-[12px]">{amount}</span>
      </div>
      <div className="flex items-center w-[150px] justify-center">
        <span className="text-[#131E3D] font-[500] text-[12px]">
          {amount_paid}
        </span>
      </div>
      <div className="flex items-center w-[150px] justify-end">
        <span className="text-[#131E3D] font-[500] text-[12px]">
          {remaining_balance}
        </span>
      </div>
    </div>
  );
};
const TableRow = ({
  iconSrc,
  name,
  description,
  id,
  success,
  amount,
  transaction_side,
  successBgColor,
}) => {
  const navigate = useNavigate();
  return (
    <div
      // onClick={() => {
      //   navigate(`/investment/${id}`);
      // }}
      className="flex cursor-pointer justify-between items-center gap-4 p-3 border-b"
    >
      <div className="flex items-center gap-4 w-full max-w-xs">
        {transaction_side?.toLowerCase() == "credit" ? (
          <img src={withdraw} alt="icon" className="w-[38px] h-[38px]" />
        ) : (
          <img src={funding} alt="icon" className="w-[38px] h-[38px]" />
        )}
        {/* <div className="w-[45px] flex-shrink-0">
          <img
            src={iconSrc}
            alt="icon"
            className="w-[38px] h-[38px] object-contain"
          />
        </div> */}
        <div className="flex flex-col">
          <span className="font-[500] text-[14px] text-[#131E3D]">{name}</span>
          <span className="text-[12px] font-[400] text-[#9C9C9E]">
            {description}
          </span>
        </div>
      </div>
      {success?.toLocaleLowerCase() === "paid" ? (
        <span className=" text-[14px] items-center capitalize  flex justify-center font-[400] bg-[#E4FFC2] px-[14px] h-[27px] p-1 rounded-[40px]  text-[#344616] ">
          {success}
        </span>
      ) : (
        <span className=" text-[14px] items-center capitalize flex justify-center font-[400] bg-[#F2F2F7] px-[14px] h-[27px] p-1 rounded-[40px]  text-[#131E3D] ">
          {success}
        </span>
      )}
      {/* <span
        className={`text-[14px] min-w-[80px] font-[400] px-[10px] justify-center items-center flex h-[27px] p-1 rounded-[40px] text-center ${successBgColor}`}
      >
        {success}
      </span> */}
      <div className="flex items-center w-[150px] justify-end">
        <span className="text-[#131E3D] font-[500] text-[14px]">{amount}</span>
      </div>
    </div>
  );
};

const InvestmentTransactionTable = ({
  investmentTransactions,
  type,
  tableStyle,
  state,
  noData,
}) => {
  const tableData =
    type === "payout"
      ? state?.paymentSchedules?.paymentSchedule
        ? state?.paymentSchedules?.paymentSchedule?.map((item) => ({
            iconSrc: icon2,
            name: timeformatter(item?.date, "formal", false, true),
            // description: timeformatter(state?.date, "formal", false, true),
            success: item?.status,
            remaining_balance: `${
              state?.investment?.currency === "NGR" ||
              state?.cycle_details?.currency === "NGR"
                ? "₦"
                : "$"
            }${formatAmount(item?.remaining_balance)}`,
            amount_paid: `${
              state?.investment?.currency === "NGR" ||
              state?.cycle_details?.currency === "NGR"
                ? "₦"
                : "$"
            }${formatAmount(item?.amount_paid)}`,
            // successBgColor: "bg-[#F2F2F7] text-[#131E3D]",
            successBgColor: "bg-[#E4FFC2] text-[#344616]",
            amount: `${
              state?.investment?.currency === "NGR" ||
              state?.cycle_details?.currency === "NGR"
                ? "₦"
                : "$"
            }${formatAmount(item?.amount)}`,
          }))
        : state?.investment?.paymentSchedules?.expected_date?.map((item) => ({
            iconSrc: icon2,
            name: timeformatter(item?.date, "formal", false, true),
            // description: timeformatter(state?.date, "formal", false, true),
            success: item?.status,
            // successBgColor: "bg-[#F2F2F7] text-[#131E3D]",
            successBgColor: "bg-[#E4FFC2] text-[#344616]",
            amount: `${
              state?.investment?.currency === "NGR" ||
              state?.cycle_details?.currency === "NGR"
                ? "₦"
                : "$"
            }${formatAmount(item?.amount)}`,
          }))
      : investmentTransactions
        ? investmentTransactions?.map((transaction) => ({
            iconSrc: icon1,
            name:
              transaction?.transaction_type === "Investment Loss Adjustment" ||
              transaction?.transaction_type === "Investment Gain Adjustment"
                ? // ? `${state?.investment_product_name} ${transaction?.transaction_type}`
                  `${transaction?.transaction_type}`
                : state?.investment?.property?.name ||
                  state?.investment?.name ||
                  state?.cycle_details?.name ||
                  state?.investment_product_name,
            description: timeformatter(
              transaction?.created_at,
              "formal",
              false,
              true,
            ),
            success: transaction?.status || "Success",
            transaction_side: transaction?.transaction_side,
            // successBgColor: "bg-[#F2F2F7] text-[#131E3D]",
            successBgColor: "bg-[#E4FFC2] text-[#344616]",
            // amount: `${
            //   state?.investment?.currency === "NGR" ||
            //   state?.cycle_details?.currency === "NGR"
            //     ? "₦"
            //     : "$"
            // }${formatAmount(
            //   type === "REAL-ESTATE" && state?.investment?.amount_per_unit
            //     ? state?.amount * state?.investment?.amount_per_unit
            //     : state?.amount
            // )}`,
            amount: `${transaction?.transaction_type === "Investment Loss Adjustment" ? "-" : ""}${
              state?.__currency === "NGR" ||
              state?.investment?.currency === "NGR" ||
              state?.cycle_details?.currency === "NGR"
                ? "₦"
                : "$"
            }${formatAmount(transaction?.amount)}`,
          }))
        : [];

  return (
    <div
      className={`w-full min-w-[550px] md:min-w-auto max-w-[689px] border-[1px] min-h-[175px] rounded-xl mb-[30px] border-[#f2f2f7] p-4 ${tableStyle}`}
    >
      <div className="flex flex-col gap-2">
        {noData ? (
          <div className="flex flex-1 flex-col justify-center items-center">
            <img
              src={emptyState}
              alt=""
              className=" mb-[5px] w-[76px] h-[76px] "
            />
            <div className=" mb-[5px] p-2 text-[16px] font-[400] text-[#9C9C9E] ">
              Payout Schedule appear here when investment starts
            </div>
          </div>
        ) : type === "payout" ? (
          <>
            <div className="flex  justify-between items-center gap-4 p-3 border-b">
              <div className="flex  items-center gap-4 w-[200px]">
                <span className="text-[13px] text-[#9C9C9E]">Payout Date</span>
              </div>
              <div className="w-[120px]">
                <h2 className="text-[#9C9C9E] text-center  text-[12px]">
                  Status
                </h2>
              </div>

              <div className="flex items-center justify-center  w-[150px] ">
                <h2 className="text-[#9C9C9E] text-center  text-[13px]">
                  Payout amount
                </h2>
              </div>
              <div className="flex items-center justify-center  w-[150px] ">
                <h2 className="text-[#9C9C9E] text-center  text-[13px]">
                  Processed amount
                </h2>
              </div>
              <div className="flex items-center justify-end   w-[150px] ">
                <h2 className="text-[#9C9C9E]   text-[13px]">Balance</h2>
              </div>
            </div>
            {tableData.map((row, index) => (
              <PayoutTableRow
                key={index}
                id={index}
                iconSrc={row.iconSrc}
                name={row.name}
                amount_paid={row?.amount_paid}
                remaining_balance={row?.remaining_balance}
                description={row.description}
                status={row.success}
                successBgColor={row.successBgColor}
                amount={row.amount}
              />
            ))}
          </>
        ) : (
          tableData.map((row, index) => (
            <TableRow
              key={index}
              id={index}
              iconSrc={row.iconSrc}
              name={row.name}
              description={row.description}
              success={row.success}
              successBgColor={row.successBgColor}
              amount={row.amount}
              transaction_side={row?.transaction_side}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default InvestmentTransactionTable;
